import React from 'react';
import Cards from '../components/cards';

function Home({cities}) {
    return (
        <div>
            <Cards />
        </div>
    )
}

export default Home